import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  appBar: {
    height: 40,
    marginTop: 48,
    padding: 0,
    backgroundColor: theme.palette.background.default,
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: '#C4C6C9',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  header: {
    height: 14,
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginLeft: 48,
    paddingLeft: 24,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      paddingLeft: 0,
      justifyContent: 'center',
    },
  },
  title: {
    color: '#000',
  },
  tab: {
    marginTop: 2,
    fontSize: 16,
    textTransform: 'capitalize',
    color: '#000',
    '&.MuiTab-root': {
      minHeight: 40,
    },
    [theme.breakpoints.down('sm')]: {
      '& + &': {
        marginLeft: 8,
      },
    },
  },
}));
